import Spinner from '../Spinner';
import PropTypes from 'prop-types';

const Table = ({
  columns,
  rows,
  emptyDataTitle,
  emptyDataText,
  onRowClick,
  disableRow,
  checkedRow,
  handleCheckBoxRowClick,
  isLoading
}) => {
  const handleRowClick = (row) => {
    if (onRowClick) {
      onRowClick(row);
    }
  };

  const checkBoxRowClickHandler = (payload) => {
    if (handleCheckBoxRowClick) {
      handleCheckBoxRowClick(payload);
    }
  };

  return (
    <div className="tableContainer">
      {isLoading ? (
        <Spinner />
      ) : rows.length === 0 ? (
        <div className="tableEmptyState">
          <div className="tableEmptyStateTitle">{emptyDataTitle}</div>
          <div className="tableEmptyStateText">{emptyDataText}</div>
        </div>
      ) : (
        <div className="table">
          <div className="tableHead">
              {columns.map((column) => (
                <div
                  className="tableCell"
                  key={column.id}
                >
                  {column.label}
                </div>
              ))}
          </div>
          <div className="tableDivider" />
            {rows.map((row, index) => (
              <div
                key={index}
                className={
                  `tableContainer ${disableRow && checkedRow && checkedRow !== row.id ? 'disabled' : ''}`
                }
                tabIndex={-1}
                onClick={(event) => {
                  if (!event.target.closest('input[type="checkbox"]')) {
                    handleRowClick(row);
                  }
                }}
              >
                {columns.map((column) => {
                  const value = row[column.id];

                  return (
                    <div
                      className="rowCell"
                      key={column.id}
                    >
                      {column.isCheckBox ? (
                        <PortalCheckBox
                          options={[
                            {
                              label: '',
                              value,
                              checked: checkedRow === value,
                              disabled: row.payload?.deleted,
                              id: `checkBoxValue_${value}`
                            }
                          ]}
                          onChange={checkBoxRowClickHandler}
                        />
                      ) : (
                        value
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          )}
    </div>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      minWidth: PropTypes.number,
      align: PropTypes.string,
      isCheckBox: PropTypes.bool
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  emptyDataTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  emptyDataText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onRowClick: PropTypes.func,
  disableRow: PropTypes.bool,
  checkedRow: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleCheckBoxRowClick: PropTypes.func,
  isLoading: PropTypes.bool
};

Table.defaultProps = {
  columns: [],
  rows: [],
  emptyDataTitle: '',
  emptyDataText: '',
  onRowClick: undefined,
  disableRow: false,
  checkedRow: undefined,
  handleCheckBoxRowClick: undefined,
  isLoading: false
};

export default Table;